

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const PMSSCORESHOWHIDE= createAsyncThunk(
  "pmsScoreShowHide/pmsScoreShowHide",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const pmsScoreShowHideSlice = createSlice({
  name: "pmsScoreShowHideSlice",
  initialState: {
    pmsScoreShowHide: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfpmsScoreShowHide: (state) => {
        state.pmsScoreShowHide.loading = false
        state.pmsScoreShowHide.error = false
        state.pmsScoreShowHide.data = []
        state.pmsScoreShowHide.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(PMSSCORESHOWHIDE.fulfilled, (state, action) => {
      state.pmsScoreShowHide = {
        ...state.pmsScoreShowHide,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(PMSSCORESHOWHIDE.pending, (state, action) => {
      state.pmsScoreShowHide = {
        ...state.pmsScoreShowHide,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(PMSSCORESHOWHIDE.rejected, (state, action) => {
      state.pmsScoreShowHide = {
        ...state.pmsScoreShowHide,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const pmsScoreShowHideAction = {
    PMSSCORESHOWHIDE,
};

export { pmsScoreShowHideAction };
export default pmsScoreShowHideSlice.reducer;
export const {setInitialStateOfpmsScoreShowHide} = pmsScoreShowHideSlice.actions
